import Types from "./Types";

const INITIAL_STATE = {
  studentExams: [],
  isLoading: false,
  count: 0,
};

export default function studentExams(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_ADMIN_STUDENT_EXAMS_MAIN_SUCCESS: {
      return {
        ...state,
        studentExams: payload.data || payload,
        count: payload.total || (Array.isArray(payload.data) ? payload.data.length : (Array.isArray(payload) ? payload.length : 0)),
      };
    }

    case Types.REDO_EXAM_SUCCESS: {
      // Refresh the list after redo
      return {
        ...state,
      };
    }

    case Types.ADD_ADMIN_STUDENT_EXAMS_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    default: {
      return state;
    }
  }
}

